import { Component, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import { UserRoles } from 'src/app/dictionaries/UserRoles';
import { ZendeskService } from 'src/app/services/zendesk.service';

@Component({
    selector: 'app-client-profile-top-buttons',
    templateUrl: './client-profile-top-buttons.component.html',
    styleUrls: ['./client-profile-top-buttons.component.scss'],
    standalone: false
})
export class ClientProfileTopButtonsComponent implements OnInit, OnChanges {
  discsFolderName = 'Discs';
  UserRoles = UserRoles;
  // Declare an EventEmmiter to emit an event when the user clicks on the "Import from Apps" button
  @Output() importFromAppsEvent = new EventEmitter<any>();
  @Output() handleAddClientUser = new EventEmitter<any>();
  @Output() libraryManagerEvent = new EventEmitter<any>();
  @Output() showMyDiagnosesEvent = new EventEmitter<any>();
  @Output() addDiagnosesEvent = new EventEmitter<any>();
  // @Output() diagnosesManagerEvent = new EventEmitter<any>();

  // Declare an EventEmmiter to emit an event when the user clicks on open dialog button
  @Output() openDialogEvent = new EventEmitter<any>();
  @Output() addConsultantEvent = new EventEmitter<any>();
  @Output() backToOverviewEvent = new EventEmitter<any>();
  @Output() shareFilesEvent = new EventEmitter<any>();

  @Input() importFromAppsBtn: boolean;
  @Input() addClientUploadCondition: boolean;
  @Input() realRole: string;
  @Input() permissions_uploadfiles: boolean;
  @Input() currentFolderName: string;
  @Input() patientType: string;
  @Input() isSpoke: boolean;
  @Input() selectedHub: any = null;

  /** Optional visibility overrides. When false, the corresponding button is hidden. Omitted/true = use existing logic. */
  @Input() showBackToOverview: boolean = true;
  @Input() showUpload: boolean = true;
  @Input() showLibraryManagerButton: boolean = true;
  @Input() showAddDiagnosis: boolean = true;
  @Input() showAddConsultant: boolean = true;
  @Input() showAddPatientUploadAccount: boolean = true;
  @Input() showShareFiles: boolean = true;
  libraryFolderName = 'Library';
  myDiagnosesConditions: any;
  upLoadConditions: any;
  isClientAndNotUploadsFolder: boolean;

  constructor(private zendesk_$: ZendeskService) {}

  ngOnInit() {
    this.setRestrictions();
  }

  backToOverview() {
    this.backToOverviewEvent.emit();
  }

  runHandleAddClientUser($event) {
    this.handleAddClientUser.emit($event);
  }

  ngOnChanges() {
    this.setRestrictions();
  }

  setRestrictions() {
    const authorizedRoles = ['Admin', 'Owner', 'Client'].includes(this.realRole);
    const currentFolder = this.currentFolderName === this.libraryFolderName;
    const externalPatient = this.patientType === 'external';

    this.myDiagnosesConditions = authorizedRoles && currentFolder && externalPatient;
    this.upLoadConditions = ![this.discsFolderName].includes(this.currentFolderName);
    this.isClientAndNotUploadsFolder =
      this.realRole !== UserRoles.client
        ? true
        : !(
            this.realRole === UserRoles.client &&
            this.currentFolderName !== this.discsFolderName &&
            this.currentFolderName !== 'Patient Upload File'
          );
  }

  openDialog($event: MouseEvent) {
    this.openDialogEvent.emit($event);
  }

  addConsultant() {
    this.addConsultantEvent.emit();
  }

  showImportFromApps() {
    const ticketBody = `Ticket body goes here`;
    this.importFromAppsEvent.emit();
    return this.zendesk_$.createTicket('Import from Apps', ticketBody).then(res => {
      console.log('Ticket created', res);
    });
  }

  showLibraryManager() {
    this.libraryManagerEvent.emit();
  }

  showMyDiagnoses() {
    this.showMyDiagnosesEvent.emit();
  }

  addDiagnoses() {
    this.addDiagnosesEvent.emit();
  }

  // showDiagnosesManager() {
  //   this.diagnosesManagerEvent.emit();
  // }

  shareFiles() {
    this.shareFilesEvent.emit();
  }
}
